export const invite = {
  fuwutiaokuan: '«Условия использования»',
  yinsizhengce: '«Политика конфиденциальности»',
  fzcg: 'Скопировано успешно',
  yqhy: "Пригласить друзей",
  fxlj: "Поделиться ссылкой",
  register_now: 'Зарегистрироваться сейчас',
  phone: 'Телефон',
  email: 'Электронная почта',
  placehold_phone: 'Введите ваш номер телефона',
  placehold_email: 'Введите ваш email',
  placehold_code: 'Реферальный код',
  argee: 'Я прочитал и соглашаюсь с',
  agreement: '«Пользовательским соглашением BiKing»',
  register: 'Регистрация',
  phone_code: 'СМС-код подтверждения',
  email_code: 'Код подтверждения по email',
  code_to_phone: 'Код подтверждения отправлен СМС на ваш телефон',
  code_to_email: 'Код подтверждения отправлен на ваш email',
  has_sent: 'Код отправлен на:',
  resend: 'Отправить повторно',
  send_code: 'Отправить код',
  unable_code: 'Не получили код?',
  set_pwd: 'Установить пароль',
  placehold_pwd: 'Введите ваш пароль',
  submit: 'Отправить',
  error_phone: 'Введите корректный номер телефона',
  error_email: 'Неверный формат email, пожалуйста, введите заново',
  error_checked: 'Пожалуйста, подтвердите согласие с условиями',
  text: 'Неверный формат пароля. Пароль должен быть длиной 8–32 символа и содержать прописные, строчные буквы и цифры.',
  validate: 'Пожалуйста, завершите проверку',
  register_success: 'Регистрация успешна!',
  welcome: 'Добро пожаловать в BiKing',
  start_trade: 'Пополните криптовалюту, чтобы начать торговать',
  safe: 'Различные способы пополнения для безопасной и удобной торговли криптовалютой',
  pay_type: 'Покупайте и продавайте криптовалюту через банковские карты или другие платёжные методы',
  right_now_download: 'Скачать сейчас',
  right_download: 'Скачать',
  'Please_enter_correct_phone_number':'Пожалуйста, введите корректный номер телефона',
  'Referral_code':'Пожалуйста, введите ваш реферальный код',
  'I_have_read_and_agree':'Я прочитал и соглашаюсь с',
  'BiKing_User_Agreement':'«Пользовательским соглашением BiKing»',
  'Please_enter_password':'Пожалуйста, введите ваш пароль',
  'Email_verification_code':'Код подтверждения по email',
  'SMS_code':'СМС-код подтверждения',
  'Incorrect_email_format_please_reenter':'Неверный формат email, пожалуйста, введите заново',
  'Please_read_and_agree_User_Agreement':'Пожалуйста, прочитайте и примите пользовательское соглашение',
  'Sent_code_to':'Код отправлен на',
  zjff: 'Выдаётся немедленно!',
  ycxdz: 'Поступление единой суммой!',
  bbsy: '0 затрат — сотни процентов прибыли!',
  sdly: 'Три причины выбрать BiKing',
  aqfktx: 'Ведущая в мире система безопасности и управления рисками',
  aqhg: 'Безопасно, соответствует требованиям, надёжная ценностная сеть. Профессиональная распределённая архитектура и защита от DDoS-атак',
  qqbthyytd: 'Глобальная локальная операционная команда',
  qqbj: 'Глобальное присутствие, локальная поддержка во многих странах, создание многофункциональной блокчейн-экосистемы',
  fwtx: 'Переосмысление клиентоориентированной системы обслуживания',
  yhzs: 'Клиент прежде всего. Уникальный механизм предварительной компенсации и Фонд защиты пользователей',
  jslc: 'Как активировать',
  zcwcjkjs: 'После завершения регистрации 1188 USDT будут зачислены на бонусный счёт; зайдите в бонусный счёт, чтобы активировать.',
  czts: 'Пример: после регистрации вы используете полученные 1000 USDT для открытия длинной позиции BTC с плечом 20x. При росте BTC на 1% вы получаете 20% прибыли (200 USDT), которую можно сразу вывести.',
  zhu: 'Примечание:',
  qzlqyky: '1188 USDT выдаются и активируются частями. Доступны для всех типов контрактов.',
  gqql: 'Срок действия 1188 USDT — 1 месяц. По истечении срока обнуляются.'
}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/ru.js